import React from "react";
import { Chip } from "@mui/material";

const statusConfig = {
  approved: { color: "#fff", bg: "linear-gradient(135deg, #43e97b, #38f9d7)", label: "Approved" },
  pending: { color: "#92400E", bg: "#FEF3C7", label: "Pending" },
  rejected: { color: "#fff", bg: "linear-gradient(135deg, #f093fb, #f5576c)", label: "Rejected" },
  active: { color: "#fff", bg: "linear-gradient(135deg, #43e97b, #38f9d7)", label: "Active" },
  inactive: { color: "#64748B", bg: "#F1F5F9", label: "Inactive" },
  archived: { color: "#64748B", bg: "#eef0f6", label: "Archived" },
  available: { color: "#fff", bg: "linear-gradient(135deg, #43e97b, #38f9d7)", label: "Available" },
  assigned: { color: "#fff", bg: "linear-gradient(135deg, #667eea, #764ba2)", label: "Assigned" },
  sick: { color: "#fff", bg: "linear-gradient(135deg, #f093fb, #f5576c)", label: "Sick" },
  casual: { color: "#fff", bg: "linear-gradient(135deg, #4facfe, #00f2fe)", label: "Casual" },
  emergency: { color: "#fff", bg: "linear-gradient(135deg, #fccb90, #d57eeb)", label: "Emergency" },
};

const StatusChip = ({ status, label, size = "small", sx = {} }) => {
  const key = status?.toLowerCase?.() || "pending";
  const config = statusConfig[key] || {
    color: "#64748B",
    bg: "#eef0f6",
    label: status,
  };

  return (
    <Chip
      label={label || config.label}
      size={size}
      sx={{
        background: config.bg,
        color: config.color,
        fontWeight: 600,
        fontSize: "0.75rem",
        height: size === "small" ? 26 : 32,
        borderRadius: "8px",
        border: "none",
        ...sx,
      }}
    />
  );
};

export default StatusChip;
